import React, { useEffect, useState } from "react";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import Grid from "@material-ui/core/Grid";
import { TooltipContent, TooltipDiv } from "./tooltip.styles";
import { TooltipProps } from "./tooltip.props";
import { TooltipContext } from "../types/tooltip.context";
import { BASE_COLORS } from "../../../emotion-theme";

export const Tooltip = withShowIf((props: TooltipProps) => {
  const [colour, setColour] = useState(BASE_COLORS.black);
  const Icon = props.icon;

  useEffect(() => {
    setColour(props.colour || BASE_COLORS.black);
  }, [props.colour]);

  return (
    <TooltipDiv>
      <TooltipContext.Provider value={{ colour }}>
        <Grid container={true}>
          <TooltipContent colour={props.colour} item={true} xs={2} sm={2} md={2} lg={2}>
            <Icon />
          </TooltipContent>
          <Grid item={true} xs={10} sm={10} md={10} lg={10}>
            {props.children}
          </Grid>
        </Grid>
      </TooltipContext.Provider>
    </TooltipDiv>
  );
});
